<template>
  <div class="service_zc">
    <!-- 服务支持 -->
    <!-- nav -->
    <index-nav></index-nav>
    <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/fw_banner.jpg" alt />
      </div>
      <!-- 详情 -->
      <div class="fwCon">
        <div class="inner">
          <div class="numList">
            <div class="numItem act">
              <div class="xu"><span>01</span></div>
              <div class="numcon">
                <span class="name">系统设计</span>
                <span class="desc">工程预算设计</span>
              </div>
            </div>
            <div class="numItem">
              <div class="xu"><span>02</span></div>
              <div class="numcon">
                <span class="name">新风系统</span>
                <span class="desc">专业性极强技能</span>
              </div>
            </div>
            <div class="numItem">
              <div class="xu"><span>03</span></div>
              <div class="numcon">
                <span class="name">通风</span>
                <span class="desc">从主机到末端</span>
              </div>
            </div>
            <div class="numItem">
              <div class="xu"><span>04</span></div>
              <div class="numcon">
                <span class="name">净化工程</span>
                <span class="desc">洁净药厂工厂</span>
              </div>
            </div>
            <div class="numItem">
              <div class="xu"><span>05</span></div>
              <div class="numcon">
                <span class="name">维护保养</span>
                <span class="desc">7*24小时为您</span>
              </div>
            </div>
          </div>
          <div class="pic"> <img src="/statics/images/info/fw_pic.png" alt /></div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {};
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {},
  methods: {},
  mounted: function() {}
};
</script>

<style>
</style>